module.exports = __webpack_public_path__ + "media/img/skrzynia-manualna-dark@3x-43ce2059.svg";